import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IResourceDto } from "../interface/user/login/IResourceDto";

enum ResourceServiceEnum {
  getResource = "",
  save = "",
  delete = "?resourceId="
}

export default class ResourceService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/resource");
  }

  public getResource = async (): Promise<IResourceDto[]> => await this.GET(ResourceServiceEnum.getResource);
  public save = async (data: IResourceDto): Promise<IResourceDto> => await this.POST(ResourceServiceEnum.getResource, data);
  public delete = async (id: number) => await this.DELETE(ResourceServiceEnum.delete + id);
}



// WEBPACK FOOTER //
// ./src/services/api/Resource.service.ts